var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
let InfosetsOverviewItem = class InfosetsOverviewItem extends Vue {
    get myLabel() {
        return this.label;
    }
    get progressPercent() {
        return Math.abs((this.progress * 100) / this.total);
    }
};
__decorate([
    Prop({ default: 0 })
], InfosetsOverviewItem.prototype, "progress", void 0);
__decorate([
    Prop({ default: 0 })
], InfosetsOverviewItem.prototype, "total", void 0);
__decorate([
    Prop({ default: '' })
], InfosetsOverviewItem.prototype, "label", void 0);
__decorate([
    Prop({ default: true })
], InfosetsOverviewItem.prototype, "showProgress", void 0);
InfosetsOverviewItem = __decorate([
    Component
], InfosetsOverviewItem);
export default InfosetsOverviewItem;
